import type { Platform } from './state';
export type DivePhase = 'surface' | 'dipping' | 'partial' | 'submerged' | 'rising';
export function divePhase(p: Platform, frame: number): DivePhase {
  if (!p.diving) return 'surface';
  const phase = (frame + p.phaseOffset) % p.divePeriod;
  if (phase < p.divePeriod - 108) return 'surface';
  if (phase < p.divePeriod - 88) return 'dipping';
  if (phase < p.divePeriod - 68) return 'partial';
  if (phase < p.divePeriod - 24) return 'submerged';
  return 'rising';
}
export const isSurfaced = (p: Platform, frame: number): boolean => divePhase(p, frame) !== 'submerged';
export const mouthOpen = (frame: number, offset = 0): boolean => (frame + offset) % 180 >= 80;
export function supports(p: Platform, x: number, frame: number): boolean {
  return x-3 >= p.x && x+3 <= p.x+p.w && isSurfaced(p,frame);
}
export function onMouth(p: Platform, x: number, frame: number): boolean {
  if (p.kind !== 'crocodile' || !mouthOpen(frame,p.phaseOffset)) return false;
  return p.speed > 0 ? x+4 > p.x+p.w-17 : x-4 < p.x+17;
}
